import { isMobile } from "@modules/util/device"
import { getQueryParameter } from "@modules/util/query-parameter"

export function getAdvertsCardType() {
    return getQueryParameter("ansicht") || (isMobile() ? "list" : "gallery")
}
